import type { PostEmailErrorReason } from '@/services/registration/types';

import type { InfoModalContentType } from '../RegistrationForm.types';

type GetInfoModalConfigType = (handleClose: () => void) => {
    [key in PostEmailErrorReason]: InfoModalContentType;
};

export const getInfoModalConfig: GetInfoModalConfigType = handleClose => ({
    existingUserStatusToTransaction: {
        title: 'Dane, które podałeś, istnieją już w naszym systemie',
        description:
            'By aktywować konto, zrób dowolny zakup z płatnością PayPo.',
        dataTestId: 'existing-user-status-to-transaction',
    },
    existingUserStatusRejected: {
        title: 'Wystąpił błąd weryfikacji podanych danych. Skontaktuj się z Biurem Obsługi Klienta',
        dataTestId: 'existing-user-status-rejected',
        buttonsProps: {
            config: [
                {
                    children: 'Skontaktuj się z BOK',
                    href: `${process.env.GATSBY_APP_URL}/p/kontakt`,
                    dataTestId:
                        'existing-user-status-rejected-button-contact-bok',
                },
                {
                    children: 'Anuluj',
                    onClick: () => handleClose(),
                    variant: 'outline',
                    dataTestId: 'existing-user-status-rejected-button-cancel',
                },
            ],
            className: 'justify-between',
        },
    },
    existingUserStatusPermitted: {
        title: 'Dane, które podałeś, istnieją już w naszym systemie',
        description:
            'E-mail z linkiem aktywacyjnym został wysłany na Twój adres mailowy. Sprawdź skrzynkę, aby aktywować swoje konto.',
        dataTestId: 'existing-user-status-permitted',
    },
    existingUser: {
        title: 'Dane, które podałeś, istnieją już w naszym systemie. Możesz się zalogować.',
        dataTestId: 'existing-user',
        buttonsProps: {
            config: [
                {
                    children: 'Zaloguj się',
                    href: `${process.env.APP_URL}/home/zaloguj`,
                    dataTestId: 'existing-user-status-permitted-button-log-in',
                },
                {
                    children: 'Anuluj',
                    onClick: () => handleClose(),
                    variant: 'outline',
                    dataTestId: 'existing-user-status-permitted-button-cancel',
                },
            ],
            className: 'justify-between',
        },
    },
    conflictData: {
        title: 'Wystąpił błąd weryfikacji podanych danych. Skontaktuj się z Biurem Obsługi Klienta',
        dataTestId: 'conflict-data',
        buttonsProps: {
            config: [
                {
                    children: 'Skontaktuj się z BOK',
                    href: `${process.env.GATSBY_APP_URL}/p/kontakt`,
                    dataTestId: 'conflict-data-button-contact-bok',
                },
                {
                    children: 'Anuluj',
                    onClick: () => handleClose(),
                    variant: 'outline',
                    dataTestId: 'conflict-data-button-cancel',
                },
            ],
            className: 'justify-between',
        },
        withIcon: true,
    },
});
